import { useIsDesktop } from '@/_hooks/useBreakpoint';

import React from 'react';
import Desktop from './branches.desktop';
import Mobile from './branches.mobile';
import { IProps } from './_types';

const BranchesMap = ({
  data,
  onClose,
  onConfirm,
  selectedBranch,
  isSelected = false,
  setSelectedBranch,
  activeShipperId,
}: IProps) => {
  const isDesktop = useIsDesktop();
  return (
    <>
      {isDesktop ? (
        <Desktop
          selectedBranch={selectedBranch}
          setSelectedBranch={setSelectedBranch}
          data={data}
          activeShipperId={activeShipperId}
        />
      ) : (
        <Mobile
          onConfirm={onConfirm}
          data={data}
          onClose={onClose}
          isSelected={isSelected}
        />
      )}
    </>
  );
};

export default BranchesMap;
